export class Program {
   constructor( public PK_ProgramID:number,public ProgramCode: string,public ProgramName: string, public Duration : string) { }
}
